/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

/**
 * Supported stores
 */
export enum Store {
  AMAZON = "AMAZON",
  APP_STORE = "APP_STORE",
  MAC_APP_STORE = "MAC_APP_STORE",
  PADDLE = "PADDLE",
  PLAY_STORE = "PLAY_STORE",
  PROMOTIONAL = "PROMOTIONAL",
  RC_BILLING = "RC_BILLING",
  ROKU = "ROKU",
  STRIPE = "STRIPE",
  TEST_STORE = "TEST_STORE",
}
